import fiftyNinthStreetBridge from '../../../media/about/new_york/59_street_bridge.jpeg';
import cupsougeBeachFishing from '../../../media/about/new_york/Cupsouge_beach_fishing.jpeg';
import brothersJuliaBoat from '../../../media/about/new_york/brothers_julia_boat.jpeg';
import deer from '../../../media/about/new_york/deer.jpeg';
import graduating from '../../../media/about/new_york/graduating.jpeg';
import lakeFishing from '../../../media/about/new_york/lake_fishing.jpeg';
import pool from '../../../media/about/new_york/pool.jpeg';
import sagHarborSunset from '../../../media/about/new_york/sag_harbor_sunset.jpeg';
import westSide from '../../../media/about/new_york/west_side.jpeg';
import westhamptonSnow from '../../../media/about/new_york/westhampton_snow.jpeg';

const newYorkStory = {
  id: "new-york",
  title: "New York",
  heroImage: fiftyNinthStreetBridge,
  gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",

  description: `I grew up in New York City and have loved the city and everything the Big Apple has had to offer since I was a little boy.  I have one brother, and when I was fourteen, my mother remarried and I inherited two more brothers as well as two sisters. The four boys - we grew together in many ways, and we would have a blast through many sorted shenanigans!`,

  gallery: [
    { type: 'image', src: graduating, alt: 'Graduation' },
    { type: 'image', src: cupsougeBeachFishing, alt: 'Fishing at Cupsogue Beach' },
    { type: 'image', src: brothersJuliaBoat, alt: 'Brothers and my girlfriend on a boat' },
    { type: 'image', src: deer, alt: 'Deer' },
    { type: 'image', src: lakeFishing, alt: 'Lake fishing' },
    { type: 'image', src: pool, alt: 'Pool' },
    { type: 'image', src: sagHarborSunset, alt: 'Sag Harbor sunset' },
    { type: 'image', src: westSide, alt: 'West Side Manhattan' },
    { type: 'image', src: westhamptonSnow, alt: 'Westhampton snowstorm' },
  ]
};

export default newYorkStory;
